// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Typography } from '@mui/material'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Container from '../../../common/container/Container'
import Loader from '../../../common/loader/Loader'
import withUser from '../../auth/withUser'
import Header from '../../header/Header'
import { i18n } from '../../index'
import type { User } from '../users/userTypes'
import CreationDialog from './components/CreationDialog/CreationDialog'
import LinksTable from './components/LinksTable/LinksTable'
import { LinkTags } from './components/LinkTags/LinkTags'
import UpdateDialog from './components/UpdateDialog/UpdateDialog'
import css from './GuidelinesAndLinks.css'
import { fetchAokFileLinks, fetchFileLinks } from './queries'

const updateCacheOnDelete = (id, companyId) => (cache) => {
  const query = companyId ? fetchAokFileLinks : fetchFileLinks
  const variables = companyId
    ? {
        companyId: companyId,
      }
    : {}
  const data = cache.readQuery({
    query: query,
    variables: variables,
  })

  const fieldName = companyId ? 'aokFileLinks' : 'fileLinks'

  cache.writeQuery({
    query: query,
    variables: variables,
    data: {
      [fieldName]: data[fieldName].filter((ts) => ts.id !== id),
    },
  })
}

type Props = {
  user: User
}

@withUser
class GuidelinesAndLinks extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      creationModalIsOpen: false,
      updateModalIsOpen: false,
      linkToBeUpdated: 'ripul',
      isAokAdmin: false,
    }
  }

  componentDidMount() {
    const { user } = this.props

    if (user.userType === 'AokAdmin') {
      this.setState({
        isAokAdmin: true,
      })
    }
  }

  onDelete = (onMutate, id, companyId) => {
    onMutate({
      variables: {
        id,
        companyId,
      },
      update: updateCacheOnDelete(id, companyId),
    })
  }
  onEdit = (link) => {
    this.setState({
      linkToBeUpdated: link,
      updateModalIsOpen: true,
    })
  }

  render() {
    const { creationModalIsOpen, updateModalIsOpen, linkToBeUpdated, isAokAdmin } = this.state
    const { user } = this.props
    return (
      <div>
        <CreationDialog
          companyId={isAokAdmin === true ? user.company.id : null}
          isOpen={creationModalIsOpen}
          close={() =>
            this.setState({
              creationModalIsOpen: false,
            })
          }
        />
        <UpdateDialog
          isOpen={updateModalIsOpen}
          close={() =>
            this.setState({
              updateModalIsOpen: false,
            })
          }
          data={linkToBeUpdated}
        />

        <Header title={i18n.t('admin.header')} />

        <Container>
          <Typography variant='h6'>{i18n.t('admin.header')}</Typography>
          <div className={css.top}>
            <Typography variant={'h6'}>{i18n.t('admin.guidelinesAndLinks.title')}</Typography>

            <Button
              onClick={() =>
                this.setState({
                  creationModalIsOpen: true,
                })
              }
              variant='contained'
              color='primary'
            >
              {i18n.t('buttons.create')}
            </Button>
          </div>

          <div className={css.linksContainer}>
            <Query query={fetchFileLinks}>
              {({ loading, error, data }) => (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  <Typography className={css.subtitle} variant={'subtitle1'}>
                    {i18n.t('admin.guidelinesAndLinks.companyTableTitle')}
                  </Typography>
                  <LinksTable data={get(data, 'fileLinks', [])} onDelete={this.onDelete} onEdit={this.onEdit} />
                </Loader>
              )}
            </Query>

            <Query
              query={fetchAokFileLinks}
              variables={{
                companyId: user.company.id,
              }}
            >
              {({ loading, error, data }) => (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  <Typography className={css.subtitle} variant={'subtitle1'}>
                    {i18n.t('admin.guidelinesAndLinks.aokTableTitle')}
                  </Typography>
                  <LinksTable
                    companyId={user.company.id}
                    data={get(data, 'aokFileLinks', [])}
                    onDelete={this.onDelete}
                    onEdit={this.onEdit}
                  />
                </Loader>
              )}
            </Query>
            <LinkTags />
          </div>
        </Container>
      </div>
    )
  }
}

export default GuidelinesAndLinks
